import Web3 from 'web3';
import axios from 'axios';
// import WalletConnect from "@walletconnect/client";
// import QRCodeModal from "@walletconnect/qrcode-modal";
// import Web3Modal from 'web3modal'
import WalletConnectProvider from '@walletconnect/web3-provider';
import { getNetWorkName, checkNetworkType, getNetworkId } from './helper.js';
import { initMagic } from './magic_flow.js';
import axiosRetry from 'axios-retry';
import EthereumProvider from '@walletconnect/ethereum-provider';
import { ethers } from 'ethers';
const projectId = '77cf80047224f1d215d18c4c8230d400';
const tokenURIPrefix = gon.tokenURIPrefix;
window.prefixPath = $('#prefix_path').val();
let smartChainNetworkId = parseInt(gon.celoChainNetworkId);
const transferProxyContractAddress = gon.transferProxyContractAddress;
const wbnbAddress = gon.wbnbAddress;
const tradeContractAddress = gon.tradeContractAddress;
let plastikTokenAddress = gon.plastikTokenAddress;
let plastikTokenDecimals = gon.plastikTokenDecimals;
const SIGNING_DOMAIN_NAME = 'PLASTIK';
const SIGNING_DOMAIN_VERSION = '2.0';
const SELLER_DOMAIN_NAME = 'PLASTIK';
const OLD_SIGNING_DOMAIN_VERSION = '1.0';

let storeFrontAddress = gon.storeFrontAddress;
let plastikCryptoAddress = gon.plastikCryptoAddress;
let plastikCryptoAddressOld = gon.plastikCryptoAddressOld;
let plastikRoleAddress = gon.plastikRoleAddress;
let plastikRoyaltyCalAddress = gon.plastikRoyaltyCalAddress;

// Web3modal instance
let web3Modal;

// Chosen wallet provider given by the dialog window
let provider;

let selectedAccount;

export async function setChainId() {
	const chainId = await window.getChainId();
	await checkNetworkType(parseInt(chainId));

	if ([97, 56].includes(parseInt(chainId))) {
		smartChainNetworkId = parseInt(gon.smartChainNetworkId);
		plastikTokenAddress = gon.plastikTokenAddress;
		plastikTokenDecimals = gon.plastikTokenDecimals;
		storeFrontAddress = gon.storeFrontAddress;
		plastikCryptoAddress = gon.plastikCryptoAddress;
		plastikCryptoAddressOld = gon.plastikCryptoAddressOld;
		plastikRoyaltyCalAddress = gon.plastikRoyaltyCalAddress;
		plastikRoleAddress = gon.plastikRoleAddress;
	} else if ([42220, 44787].includes(parseInt(chainId))) {
		smartChainNetworkId = parseInt(gon.celoChainNetworkId);
		plastikTokenAddress = gon.celoPlastikTokenAddress;
		plastikTokenDecimals = gon.celoPlastikTokenDecimals;
		storeFrontAddress = gon.storeFrontAddressCelo;
		plastikCryptoAddress = gon.plastikCryptoAddressCelo;
		plastikCryptoAddressOld = gon.plastikCryptoAddressCeloOld;
		plastikRoyaltyCalAddress = gon.plastikRoyaltyCalAddressCelo;
		plastikRoleAddress = gon.plastikRoleAddressCelo;
	}
}

$(async function () {
	if (gon.session) {
		await initWeb3();
		const account = await getCurrentAccount();

		if (account) {
			await showDataWallet();
			setInterval(async function () {
				await window.checkNetwork();
			}, 20000);
		}
		if (window.isMagicUser()) {
			if ($('#user_email').val()) {
				$('#user_email').prop('disabled', true);
			}
		}
	}
});

async function initWeb3() {
	let connected_by = window.localStorage.getItem('CONNECTED');
	console.log('connect_by', connected_by);

	switch (connected_by) {
		case 'metamask':
			provider = metamaskConnector();
			break;
		case 'walletconnect':
			provider = await walletConnector();
			break;

		default:
			provider = null;
			break;
	}

	console.log('provider-first', provider);
	if (gon.session) {
		await setChainId();
		if (provider && connected_by != 'magic') {
			try {
				await subscribeProvider();
				console.log('gon.session', gon.session);
				await window.fetchAccountData();

				return;
			} catch (e) {
				toastr.error('You got logged out due to session ended');
				await destroySession();
				console.log(e);
			}
		} else {
			console.log('connected-magic', connected_by);
			await window.fetchAccountData();
			return;
		}
	}
}

const swichNetwork = async chainId => {
	const currentChainId = await getNetworkId();

	if (currentChainId !== chainId) {
		try {
			await web3.currentProvider.request({
				method: 'wallet_switchEthereumChain',
				params: [{ chainId: Web3.utils.toHex(chainId) }]
			});
		} catch (switchError) {
			// This error code indicates that the chain has not been added to MetaMask.
			if (switchError.code === 4902) {
				await addNetwork([97, 56].includes(parseInt(chainId)) ? 'BSC' : 'CELO');
			} else {
				throw new Error(switchError);
			}
		}
	}
};

function camelToUnderscore(key) {
	return key.replace(/([A-Z])/g, '_$1').toLowerCase();
}

function convertObjectFormat(object) {
	if (!Object.keys(object).length) return object;

	let newObject = {};

	for (let key in object) {
		newObject[camelToUnderscore(key)] = object[key];
	}

	return newObject;
}

window.proceedWithLoad = async function proceedWithLoad() {
	var account = $('#account').val();
	const plastikBalanace = $('#eth_balance').text();
	const networkType = $('#network_type').val();
	const userMail = $('#user_mail').val();
	if ($('#condition1').is(':checked') && $('#condition2').is(':checked')) {
		$('.proceedBtn').prop('disabled', true).css('cursor', 'not-allowed');
		$('#process-terms-loading-icon').removeClass('d-none');
		await createUserSession(account, plastikBalanace, true, {
			email: userMail
		});
		window.location.reload();
	} else {
		toastr.error('Please accept the conditions to proceed');
	}
};

export async function createUserSession(
	address,
	balance,
	destroySession,
	userInfo
) {
	// save info of user added token
	let currentAddedTokenStatus =
		JSON.parse(window.localStorage.getItem('ADDED_TOKEN_STATUS')) || {};

	try {
		const resp = await $.post(`/sessions`, {
			address: address,
			balance: balance,
			destroy_session: destroySession,
			is_magic_user: isMagicUser(),
			user_info: convertObjectFormat(userInfo || {}),
			added_token_status: currentAddedTokenStatus
		});

		try {
			window.smartlook('identify', address, gon.currentUserInfo);
		} catch (e) {
			console.log(`===Smartlook error on identify: ${e} ===`);
		}
	} catch (err) {
		console.log('User Session Create Error', err);
	}
}

function updateTokenId(tokenId, collectionId) {
	var request = $.ajax({
		url: `/collections/${collectionId}/update_token_id`,
		async: false,
		type: 'POST',
		data: { tokenId: tokenId, collectionId: collectionId },
		dataType: 'script'
	});
	request.done(function (msg) {
		console.log('Token Id updated.');
	});
	request.fail(function (jqXHR, textStatus) {
		console.log('Failed to update token id');
	});
}

function updateMintedCollection(collectionId) {
	var request = $.ajax({
		url: `/collections/${collectionId}/update_token_id`,
		async: false,
		type: 'POST',
		data: { collectionId: collectionId },
		dataType: 'script'
	});
	request.done(function (msg) {
		console.log('Token Id updated.');
	});
	request.fail(function (jqXHR, textStatus) {
		console.log('Failed to update token id');
	});
}

function createContract(
	name,
	symbol,
	contract_address,
	contractType,
	collectionId
) {
	var request = $.ajax({
		url: '/users/create_contract',
		async: false,
		type: 'POST',
		data: {
			name: name,
			symbol: symbol,
			contract_address: contract_address,
			contract_type: contractType,
			collection_id: collectionId
		},
		dataType: 'script'
	});
	request.done(function (msg) {
		console.log('Token Id updated.');
	});
	request.fail(function (jqXHR, textStatus) {
		console.log('Failed to update token id');
	});
}

function updateCollectionBuy(
	collectionId,
	quantity,
	transactionHash,
	buyerAddress
) {
	const urlParams = new URLSearchParams(window.location.search);

	$.ajax({
		url: '/collections/' + collectionId + '/buy',
		type: 'POST',
		async: false,
		data: {
			quantity: quantity,
			transaction_hash: transactionHash,
			buyer_address: buyerAddress,
			campaign_id: urlParams.get('campaign_id')
		},
		dataType: 'script',
		success: function (respVal) {
			console.log(respVal);
		}
	});
}

function updateCollectionSell(
	collectionId,
	buyerAddress,
	bidId,
	transactionHash
) {
	var request = $.ajax({
		url: '/collections/' + collectionId + '/sell',
		type: 'POST',
		async: false,
		data: {
			address: buyerAddress,
			bid_id: bidId,
			transaction_hash: transactionHash
		},
		dataType: 'script',
		success: function (respVal) {
			console.log(respVal);
		}
	});
}

function updateOwnerTransfer(collectionId, recipientAddress, transactionHash) {
	var request = $.ajax({
		url: '/collections/' + collectionId + '/owner_transfer',
		type: 'POST',
		async: false,
		data: {
			recipient_address: recipientAddress,
			transaction_hash: transactionHash
		},
		dataType: 'script',
		success: function (respVal) {
			console.log(respVal);
		}
	});
}

function updateBurn(collectionId, transactionHash) {
	var request = $.ajax({
		url: '/collections/' + collectionId + '/burn',
		type: 'POST',
		async: false,
		data: { transaction_hash: transactionHash },
		dataType: 'script',
		success: function (respVal) {
			console.log(respVal);
		}
	});
}

function signMetadataHash(collectionId, contractAddress) {
	var sign;
	var request = $.ajax({
		url: `/collections/${collectionId}/sign_metadata_hash`,
		type: 'POST',
		async: false,
		data: { contract_address: contractAddress },
		dataType: 'json'
	});
	request.done(function (msg) {
		console.log(msg);
		sign = msg['signature'];
	});
	request.fail(function (jqXHR, textStatus) {
		console.log('Bidding failed. Please contact support');
	});
	return sign;
}

function updateSignature(collectionId, sign) {
	const is_art_supporter = $('#is_art_supporter').val() || false;
	let url = `/collections/${collectionId}/sign_fixed_price`;
	let data = { sign: sign };
	if (is_art_supporter == 'true') {
		url = `/collections/${collectionId}/sign_fixed_price_for_resell_nft_multiple`;
		data = {
			sign: sign,
			instantPrice: $('#instant-price').val(),
			quantity: $('#number_of_items').val()
		};
	}

	var request = $.ajax({
		url: url,
		type: 'POST',
		async: false,
		data: data,
		dataType: 'script'
	});
	request.done(function (msg) {
		let receivedCelo = window.localStorage.getItem('RECEIVED_CELO');
		let firstTransactionHash = window.localStorage.getItem(
			'FIRST_TRANSACTION_HASH'
		);

		if (receivedCelo && firstTransactionHash) {
			saveCollectionCreatedToFirestore(firstTransactionHash);
		}

		console.log('Signature updated.');
	});
	request.fail(function (jqXHR, textStatus) {
		console.log('Signature update failed. Please contact support');
	});
}

window.getContractABIAndBytecode = function getContractABIAndBytecode(
	contractAddress,
	type,
	shared = true,
	new_sc = 'true',
	contractVersion = gon.latestVersion
) {
	var res;
	var url = new_sc === 'true' || new_sc ? '/contract_abi' : '/old_contract_abi';

	var request = $.ajax({
		async: false,
		url: url,
		type: 'GET',
		data: {
			contract_address: contractAddress,
			type: type,
			shared: shared,
			contract_version: contractVersion
		},
		dataType: 'json'
	});

	request.done(function (msg) {
		res = msg;
	});

	request.fail(function (jqXHR, textStatus) {
		console.log(textStatus);
	});
	return res;
};

function splitSign(sign) {
	sign = sign.slice(2);
	var r = `0x${sign.slice(0, 64)}`;
	var s = `0x${sign.slice(64, 128)}`;
	var v = window.web3.utils.toDecimal(`0x${sign.slice(128, 130)}`);
	return [v, r, s];
}

window.getContract = async function getContract(
	contractAddress,
	type,
	shared = true,
	new_sc = 'true'
) {
	console.log(contractAddress, type, shared);
	var res = getContractABIAndBytecode(contractAddress, type, shared, new_sc);
	var contractObj = await new window.web3.eth.Contract(
		res['compiled_contract_details']['abi'],
		contractAddress
	);
	console.log(contractObj);
	return contractObj;
};

window.deployContract = async function deployContract(
	abi,
	bytecode,
	name,
	symbol,
	contractType,
	collectionId
) {
	const contractDeploy = new window.web3.eth.Contract(abi);
	var contractAddress;
	var account = await getCurrentAccount();

	// funding to user if not enough funds
	await fundingToUser(0.08);

	contractDeploy
		.deploy({
			data: bytecode,
			arguments: [name, symbol, tokenURIPrefix]
		})
		.send({
			from: account
		})
		.then(deployment => {
			console.log('Contract was deployed at the following address:');
			console.log(deployment.options.address);
			contractAddress = deployment.options.address;
			$('#nft_contract_address').val(contractAddress);
			createContract(name, symbol, contractAddress, contractType, collectionId);
			window.contractDeploySuccess(contractAddress, contractType);
		})
		.catch(err => {
			console.error(err);
			window.contractDeployFailed(err['message']);
		});
};

window.deployCollectionContract = async function deployCollectionContract(
	abi,
	bytecode,
	name,
	symbol,
	contractType,
	collectionId,
	contractReturn,
	isModalForm = false
) {
	const contractDeploy = new window.web3.eth.Contract(abi);

	var contractAddress;
	var account = await getCurrentAccount();
	var arg =
		contractType == 'multiple_nft'
			? [plastikCryptoAddress, plastikRoleAddress]
			: [plastikCryptoAddress, plastikRoleAddress, name, symbol];
	var gasLimit = await getGasLimit(
		contractDeploy.deploy({
			data: bytecode,
			arguments: arg
		})
	);

	await fundingToUser(0.08);

	await contractDeploy
		.deploy({
			data: bytecode,
			arguments: arg
		})
		.send({
			from: account,
			gasLimit: gasLimit
		})
		.on('transactionHash', function (hash) {
			let receivedCelo = window.localStorage.getItem('RECEIVED_CELO');
			if (receivedCelo && hash) {
				saveCollectionCreatedToFirestore(hash);
			}
			console.log('hash', hash);
		})
		.then(deployment => {
			console.log('Contract was deployed at the following address:');
			console.log(deployment.options.address);
			contractAddress = deployment.options.address;
			$(contractReturn).val(contractAddress);
			// createContract(name, symbol, contractAddress, contractType, collectionId);
			window.updateCollectionAddress(contractReturn, isModalForm);
		})
		.catch(err => {
			console.error(err);
			window.contractDeployFailed(err['message']);
		});
};

window.approveNFT = async function approveNFT(
	contractType,
	contractAddress,
	sharedCollection,
	sendBackTo = 'collection',
	new_sc = 'true',
	approvingContract = null
) {
	try {
		var account = await getCurrentAccount();

		if (account == null) {
			return toastr.error(
				'Something went wrong, we were not able to recover your balance, please try again'
			);
		}

		// funding to user if not enough funds
		await fundingToUser();

		console.log(contractAddress, contractType, sharedCollection);
		if (!approvingContract) {
			approvingContract = storeFrontAddress;
		}
		console.log(
			'getting the contract',
			contractAddress,
			contractType,
			sharedCollection,
			new_sc
		);
		window.contract = await getContract(
			contractAddress,
			contractType,
			sharedCollection,
			new_sc
		);
		console.log(
			'got the contract, calling isApprovedForAll',
			account,
			approvingContract
		);
		var isApproved = await window.contract.methods
			.isApprovedForAll(account, approvingContract)
			.call();
		console.log('isApproved result', isApproved);
		if (!isApproved) {
			console.log('calling setApprovalForAll', approvingContract, account);
			var receipt = await window.contract.methods
				.setApprovalForAll(approvingContract, true)
				.send({ from: account })
				.on('transactionHash', function (hash) {
					window.localStorage.setItem('FIRST_TRANSACTION_HASH', hash);
					console.log('hash', hash);
				});
			console.log('setApprovalForAll called');
		}

		if (sendBackTo == 'executeBid') {
			return window.approveBidSuccess();
		} else {
			return window.collectionApproveSuccess(contractType);
		}
	} catch (err) {
		console.error(err);
		if (sendBackTo == 'executeBid') {
			return window.approveBidFailed(err['message']);
		} else {
			return window.collectionApproveFailed(err['message']);
		}
	}
};

window.mobileAndTabletCheck = function () {
	let check = false;
	(function (a) {
		if (
			/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
				a
			) ||
			/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
				a.substr(0, 4)
			)
		)
			check = true;
	})(navigator.userAgent || navigator.vendor || window.opera);
	return check;
};

window.approveResaleNFT = async function approveResaleNFT(
	contractType,
	contractAddress,
	sharedCollection,
	approvingContract = null,
	new_sc = 'true',
	artSupporterId = null
) {
	try {
		console.log(contractAddress, contractType, sharedCollection, new_sc);
		const isMerged = $('#is_merged').text();
		if (!approvingContract) {
			approvingContract = storeFrontAddress;
		}
		var account = await getCurrentAccount();

		if (account == null) {
			return toastr.error(
				'Something went wrong, we were not able to recover your balance, please try again'
			);
		}

		console.log(`resell approvingContract: ${approvingContract}`);
		console.log(`resell contractAddress: ${contractAddress}`);

		console.log(
			'getting the contract',
			contractAddress,
			contractType,
			sharedCollection,
			new_sc
		);
		window.contract = await getContract(
			contractAddress,
			contractType,
			sharedCollection,
			new_sc
		);
		console.log(
			'got the contract, calling isApprovedForAll',
			account,
			approvingContract
		);
		var isApproved = await window.contract.methods
			.isApprovedForAll(account, approvingContract)
			.call();
		console.log('isApproved result', isApproved);
		if (!isApproved) {
			console.log('calling setApprovalForAll', approvingContract, account);
			var receipt = await window.contract.methods
				.setApprovalForAll(approvingContract, true)
				.send({ from: account });
			console.log('setApprovalForAll called');
		}

		if (contractType == 'multiple_nft') {
			return window.approveResaleSuccessMultipleNft(
				contractType,
				artSupporterId
			);
		} else {
			return window.approveResaleSuccess(contractType);
		}
	} catch (err) {
		console.error(err);
		return window.approveResaleFailed(err['message']);
	}
};

//TODO: OPTIMIZE
window.isApprovedNFT = async function isApprovedNFT(
	contractType,
	contractAddress
) {
	try {
		var contract = await getContract(contractAddress, contractType);
		var account = await getCurrentAccount();
		var isApproved = await contract.methods
			.isApprovedForAll(account, transferProxyContractAddress)
			.call();
		return isApproved;
	} catch (err) {
		console.error(err);
	}
};

window.burnNFT = async function burnNFT(
	contractType,
	contractAddress,
	tokenId,
	supply = 1,
	collectionId,
	sharedCollection
) {
	try {
		var contract = await getContract(
			contractAddress,
			contractType,
			sharedCollection
		);
		var account = await getCurrentAccount();
		if (contractType == 'nft1155') {
			var receipt = await contract.methods
				.burn(tokenId, supply)
				.send({ from: account });
		} else if (contractType == 'multiple_nft') {
			var receipt = await contract.methods
				.burn(account, tokenId, supply)
				.send({ from: account });
		} else {
			var receipt = await contract.methods
				.burn(tokenId)
				.send({ from: account });
		}
		await updateBurn(collectionId, receipt.transactionHash);
		return window.burnSuccess(receipt.transactionHash);
	} catch (err) {
		console.error(err);
		return window.burnFailed(err['message']);
	}
};

window.directTransferNFT = async function directTransferNFT(
	contractType,
	contractAddress,
	recipientAddress,
	tokenId,
	supply = 1,
	shared,
	collectionId,
	new_sc = 'true'
) {
	try {
		console.log(
			contractType,
			contractAddress,
			recipientAddress,
			tokenId,
			supply,
			shared,
			collectionId
		);
		var contract = await getContract(
			contractAddress,
			contractType,
			shared,
			new_sc
		);
		var account = await getCurrentAccount();
		if (contractType == 'nft1155' || contractType == 'multiple_nft') {
			// TODO: Analyse and use proper one in future
			var tempData =
				'0x6d6168616d000000000000000000000000000000000000000000000000000000';
			var receipt = await contract.methods
				.safeTransferFrom(account, recipientAddress, tokenId, supply, tempData)
				.send({ from: account });
		} else {
			var receipt = await contract.methods
				.safeTransferFrom(account, recipientAddress, tokenId)
				.send({ from: account });
		}
		await updateOwnerTransfer(
			collectionId,
			recipientAddress,
			receipt.transactionHash
		);
		return window.directTransferSuccess(receipt.transactionHash, collectionId);
	} catch (err) {
		console.error(err);
		return window.directTransferFailed(err['message']);
	}
};

window.approveERC20 = async function approveERC20(
	contractAddress,
	contractType,
	amount,
	decimals = 18,
	sendBackTo = 'Bid',
	qty = [1]
) {
	try {
		const priceRatio = await fetchPriceRatio();
		const collectionDetails = await fetchCollectionDetails();
		let ratio = BigNumber(priceRatio.sellPrice.ratio);
		console.log(
			contractAddress,
			contractType,
			gon.collection_data['contract_shared']
		);
		amount = roundNumber(
			mulBy((amount * 10.04 ** decimals) / ratio, 10 ** decimals),
			0
		);
		var approvedAmount = await approvedTokenBalance(contractAddress);

		// var tokenBalance = await tokenBalance(contractAddress, decimals);
		if (parseInt(amount) < parseInt(approvedAmount)) {
			if (sendBackTo == 'Buy') {
				return window.buyApproveSuccess(null, contractAddress);
			} else if (sendBackTo == 'Merge') {
				return window.processMergeNFT(null, contractAddress, qty);
			} else {
				return window.bidApproveSuccess(null, contractAddress);
			}
		}
		var compiledContractDetails = getContractABIAndBytecode(
			contractAddress,
			contractType,
			gon.collection_data['contract_shared']
		);
		var abi = compiledContractDetails['compiled_contract_details']['abi'];
		var contract = await new window.web3.eth.Contract(abi, contractAddress);
		var account = await getCurrentAccount();
		console.log(compiledContractDetails);
		console.log(account);
		console.log(contractAddress);
		var receipt = await contract.methods
			.approve(collectionDetails['asset_storefront_address'], amount)
			.send({ from: account });
		if (sendBackTo == 'Buy') {
			return window.buyApproveSuccess(receipt.transactionHash, contractAddress);
		} else if (sendBackTo == 'Merge') {
			return window.processMergeNFT(
				receipt.transactionHash,
				contractAddress,
				qty
			);
		} else {
			return window.bidApproveSuccess(receipt.transactionHash, contractAddress);
		}
	} catch (err) {
		console.error(err);
		if (sendBackTo == 'Buy') {
			return window.buyApproveFailed(err['message']);
		} else {
			return window.bidApproveFailed(err['message']);
		}
	}
};

window.approvedTokenBalance = async function approvedTokenBalance(
	contractAddress
) {
	var contract = await getContract(contractAddress, 'erc20', false);
	var account = await getCurrentAccount();
	var balance = await contract.methods
		.allowance(account, storeFrontAddress)
		.call();
	return balance;
};

window.convertWBNB = async function convertWBNB(
	amount,
	sendBackTo = 'Bid',
	decimals = 18
) {
	try {
		amount = roundNumber(mulBy(amount, 10 ** decimals), 0);
		var compiledContractDetails = getContractABIAndBytecode(
			wbnbAddress,
			'erc20'
		);
		var abi = compiledContractDetails['compiled_contract_details']['abi'];
		var contract = await new window.web3.eth.Contract(abi, wbnbAddress);
		var account = await getCurrentAccount();
		var receipt = await contract.methods
			.deposit()
			.send({ from: account, value: amount });
		if (sendBackTo == 'Buy') {
			return window.buyConvertSuccess(receipt.transactionHash);
		} else {
			return window.bidConvertSuccess(receipt.transactionHash);
		}
	} catch (err) {
		console.error(err);
		if (sendBackTo == 'Buy') {
			return window.bidConvertFailed(err['message']);
		} else {
			return window.bidConvertFailed(err['message']);
		}
	}
};

window.updateBuyerServiceFee = async function updateBuyerServiceFee(
	buyerFeePermille
) {
	try {
		var compiledContractDetails = getContractABIAndBytecode(
			tradeContractAddress,
			'trade'
		);
		var abi = compiledContractDetails['compiled_contract_details']['abi'];
		var contract = await new window.web3.eth.Contract(
			abi,
			tradeContractAddress
		);
		var account = await getCurrentAccount();
		var gasPrices = await gasPrice();
		console.log(gasPrices);
		var receipt = await contract.methods
			.setBuyerServiceFee(buyerFeePermille)
			.send({ from: account, gas: 1500000, gasPrice: String(gasPrices) });
		console.log('buyer', String(receipt.status));
		if (String(receipt.status) === 'true') {
			$('form#fee_form').submit();
			$('div.loading-gif.displayInMiddle').hide();
		}
	} catch (err) {
		console.error(err);
		return false;
	}
};

window.updateSellerServiceFee = async function updateSellerServiceFee(
	sellerFeePermille
) {
	try {
		var compiledContractDetails = getContractABIAndBytecode(
			tradeContractAddress,
			'trade'
		);
		var abi = compiledContractDetails['compiled_contract_details']['abi'];
		var contract = await new window.web3.eth.Contract(
			abi,
			tradeContractAddress
		);
		var account = await getCurrentAccount();
		var gasPrices = await gasPrice();
		console.log(gasPrices);
		var receipt = await contract.methods
			.setSellerServiceFee(sellerFeePermille)
			.send({ from: account, gas: 1500000, gasPrice: String(gasPrices) });
		console.log('seller', receipt);
		console.log(String(receipt.status));
		if (String(receipt.status) === 'true') {
			$('form#fee_form').submit();
			$('div.loading-gif.displayInMiddle').hide();
		}
	} catch (err) {
		console.error(err);
	}
};

window.bidAsset = async function bidAsset(
	assetAddress,
	tokenId,
	qty = 1,
	amount,
	payingTokenAddress,
	decimals = 18,
	collectionId,
	bidPayAmt
) {
	try {
		console.log(
			assetAddress,
			tokenId,
			qty,
			amount,
			payingTokenAddress,
			decimals,
			collectionId,
			bidPayAmt
		);
		var amountInDec = roundNumber(mulBy(amount, 10 ** decimals), 0);
		console.log(amountInDec);
		var messageHash = window.web3.utils.soliditySha3(
			assetAddress,
			tokenId,
			payingTokenAddress,
			amountInDec,
			qty
		);
		console.log(messageHash);
		var account = await getCurrentAccount();
		const signature = await window.web3.eth.personal.sign(messageHash, account);
		await placeBid(collectionId, signature, qty, {
			asset_address: assetAddress,
			token_id: tokenId,
			quantity: qty,
			amount: bidPayAmt,
			amount_with_fee: amount,
			payment_token_address: payingTokenAddress,
			payment_token_decimals: decimals
		});
		return window.bidSignSuccess(collectionId);
	} catch (err) {
		console.error(err);
		return window.bidSignFailed(err['message']);
	}
};

window.signSellOrder = async function signSellOrder(
	amount,
	decimals,
	paymentAssetAddress,
	tokenId,
	assetAddress,
	collectionId,
	donation,
	sendBackTo = '',
	quantity = 1,
	contractType = 'art_nft',
	plastik_crypto_address = null
) {
	try {
		if (contractType !== 'art_nft' && contractType !== 'multiple_nft')
			amount = 1;
		amount = roundNumber(mulBy(amount, 10 ** decimals), 0);
		// var messageHash = window.web3.utils.soliditySha3(assetAddress, tokenId, paymentAssetAddress, amount);
		var account = await getCurrentAccount();
		// const fixedPriceSignature = await window.web3.eth.personal.sign(messageHash, account);
		var sellOrder = {
			tokenAddress: assetAddress,
			tokenId: parseInt(tokenId),
			price: parseInt(amount),
			amount: parseInt(quantity),
			erc20Address: paymentAssetAddress,
			ngoFeePct: parseInt(donation) * 100,
			sellerAddress: account
		};

		if (plastik_crypto_address) plastikCryptoAddress = plastik_crypto_address;

		var domainType = {
			EIP712Domain: [
				{ name: 'name', type: 'string' },
				{ name: 'version', type: 'string' },
				{ name: 'chainId', type: 'uint256' },
				{ name: 'verifyingContract', type: 'address' }
			],
			SellRequest: [
				{ name: 'tokenAddress', type: 'address' },
				{ name: 'tokenId', type: 'uint256' },
				{ name: 'price', type: 'uint256' },
				{ name: 'amount', type: 'uint256' },
				{ name: 'erc20Address', type: 'address' },
				{ name: 'ngoFeePct', type: 'uint96' },
				{ name: 'sellerAddress', type: 'address' }
			]
		};

		var domain = {
			name: SELLER_DOMAIN_NAME,
			version: SIGNING_DOMAIN_VERSION,
			verifyingContract: plastikCryptoAddress,
			chainId: smartChainNetworkId
		};
		console.log(`resell art plastikCrypto address: ${plastikCryptoAddress}`);
		console.log(`resell art smartChainNetworkId: ${smartChainNetworkId}`);
		console.log(sellOrder);
		console.log(JSON.stringify(sellOrder));

		const dataToSign = JSON.stringify({
			types: domainType,
			domain: domain,
			primaryType: 'SellRequest',
			message: sellOrder
		});

		await window.web3.currentProvider.sendAsync(
			{
				method: 'eth_signTypedData_v4',
				params: [account, dataToSign],
				from: account
			},
			function (err, result) {
				if (err) return console.dir(err);
				if (result.error) {
					return console.error('ERROR', result);
				}

				let connected_by = window.localStorage.getItem('CONNECTED');

				let signResult = result.result;
				if (connected_by == 'walletconnect') {
					signResult = result;
				}

				updateSignature(collectionId, signResult);
				if (sendBackTo == 'update') {
					return window.updateSignFixedSuccess(collectionId, contractType);
				} else {
					return window.bidSignFixedSuccess(collectionId, contractType);
				}
			}
		);

		// await updateSignature(collectionId, fixedPriceSignature)
	} catch (err) {
		console.error(err);
		if (sendBackTo == 'update') {
			return window.updateSignFixedFailed(err['message']);
		} else {
			return window.bidSignFixedFailed(err['message']);
		}
	}
};

window.executeBid = async function executeBid(
	buyer,
	buyingAssetType,
	buyingAssetAddress,
	tokenId,
	paymentAmt,
	buyingAssetQty,
	paymentAssetAddress,
	decimals,
	buyerSign,
	collectionId,
	bidId
) {
	try {
		paymentAmt = roundNumber(mulBy(paymentAmt, 10 ** decimals), 0);
		var unitPrice = 1;
		var compiledContractDetails = getContractABIAndBytecode(
			tradeContractAddress,
			'trade'
		);
		var abi = compiledContractDetails['compiled_contract_details']['abi'];
		var contract = await new window.web3.eth.Contract(
			abi,
			tradeContractAddress
		);
		var account = await getCurrentAccount();
		var orderStruct = [
			account,
			buyer,
			paymentAssetAddress,
			buyingAssetAddress,
			buyingAssetType,
			unitPrice,
			paymentAmt,
			tokenId,
			buyingAssetQty
		];
		var gasPrices = await gasPrice();
		var receipt = await contract.methods
			.executeBid(orderStruct, splitSign(buyerSign))
			.send({ from: account, gas: 1500000, gasPrice: String(gasPrices) });
		await updateCollectionSell(
			collectionId,
			buyer,
			bidId,
			receipt.transactionHash
		);
		return window.acceptBidSuccess(collectionId);
	} catch (err) {
		console.error(err);
		return window.acceptBidFailed(err['message']);
	}
};

window.ethBalance = async function ethBalance() {
	var account = await getCurrentAccount();
	var bal = await window.web3.eth.getBalance(account);
	var plastikBalanace = roundNumber(web3.utils.fromWei(bal, 'ether'), 4);
	return plastikBalanace;
};

window.updateBalance = async function updateBalance() {
	try {
		console.log('plastikTokenAddress', plastikTokenAddress);
		var plastikBalanace = await tokenBalance(
			plastikTokenAddress,
			plastikTokenDecimals
		);
		let plastikUsdPrice = gon.plastikUsdPrice;
		var currentAction = $('meta[name=psj]').attr('action');

		console.log('CALL BALANCE');

		$('#cur-balance-as-number').val(plastikBalanace);

		if (['checkout_prg', 'checkout_art'].includes(currentAction)) {
			await triggerTotalPriceCalculation();
		}

		$('.curBalance').html(
			`$${formatFloatNumber(plastikBalanace * plastikUsdPrice)} USD`
		);

		// if (plastikBalanace > 1000000) {
		//   plastikBalanace = (plastikBalanace / 1000000).toFixed(1) + 'M'
		// } else if (plastikBalanace > 1000) {
		//   plastikBalanace = (plastikBalanace / 1000).toFixed(2) + 'K'
		// } else if (plastikBalanace > 0) {
		//   plastikBalanace = (parseFloat(plastikBalanace)).toFixed(2)
		// }

		// $('.curEthBalance').text(plastikBalanace)

		// return plastikBalanace
	} catch (e) {
		console.error('Unable to update balance', e);
	}

	return 0;
};

window.tokenBalance = async function tokenBalance(contractAddress, decimals) {
	var abi = [
		{
			constant: true,
			inputs: [{ name: '_owner', type: 'address' }],
			name: 'balanceOf',
			outputs: [{ name: 'balance', type: 'uint256' }],
			payable: false,
			type: 'function'
		}
	];

	console.log('token abi', abi);
	var contract = await new window.web3.eth.Contract(abi, contractAddress);
	console.log('contract', contract);
	var account = await getCurrentAccount();
	console.log('account', account);
	var balance = 0;
	await contract.methods
		.balanceOf(account)
		.call()
		.then(amount => {
			balance = amount;
		})
		.catch(async error => {
			console.log(error);
			console.log('is_connected', window.ethereum.isConnected());
			let connected_by = window.localStorage.getItem('CONNECTED');
			if (connected_by == 'metamask') {
				const account = (await window.web3.eth.getAccounts())[0];
				const accounts = await window.ethereum.request({
					method: 'eth_requestAccounts'
				});
				console.log('net work wrong', account);
			}
		});
	balance = roundNumber(divBy(balance, 10 ** decimals), 4);
	console.log('balance', balance);
	return balance;
};

window.getNetworkType = async function getNetworkType(provider = null) {
	if (!provider) {
		// if login through Magic
		var type = await web3.eth.net.getNetworkType();

		console.log('getNetworkType', type);
		return type;
	}

	if (provider.isMetaMask) {
		var type = 'private';
		await web3.eth.net
			.getNetworkType()
			.then(type => {
				console.log(type);
				type = type;
			})
			.catch(async error => {
				let connected_by = window.localStorage.getItem('CONNECTED');
				if (connected_by == 'metamask') {
					const account = (await window.web3.eth.getAccounts())[0];
					const accounts = await window.ethereum.request({
						method: 'eth_requestAccounts'
					});
					console.log('net work wrong', account);
				}
			});

		console.log('getNetworkType', type);
		return type;
	} else if (provider.isWalletConnect) {
		let chainId = provider.chainId;

		console.log('getNetworkType', chainId);
		return chainId;
	}
};

window.isMagicUser = function isMagicUser() {
	return !provider;
};

async function walletConnector() {
	let provider = await EthereumProvider.init({
		projectId,
		showQrModal: true,
		network: 'celo',
		optionalMethods: ['eth_signTypedData', 'eth_signTypedData_v4', 'eth_sign'],
		qrModalOptions: {
			themeMode: 'light',
			themeVariables: {
				'--wcm-z-index': '10001'
			},
			enableExplorer: true,
			explorerRecommendedWalletIds: [
				'd01c7758d741b363e637a817a09bcf579feae4db9f5bb16f599fdd1f66e2f974',
				'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96',
				'4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0',
				'38f5d18bd8522c244bdd70cb4a68e0e718865155811c043f052fb9f1c51de662'
			],
			privacyPolicyUrl: undefined,
			explorerDenyList: undefined,
			termsOfServiceUrl: undefined
		},
		rpcUrl: 'https://rpc.ankr.com/celo',
		chains: [parseInt(gon.celoChainNetworkId)],
		events: ['accountsChanged', 'chainChanged', 'disconnect'],
		rpcMap: {
			42220: 'https://forno.celo.org',
			44787: 'https://alfajores-forno.celo-testnet.org',
			56: 'https://bsc-dataseed.binance.org',
			97: 'https://data-seed-prebsc-1-s1.binance.org:8545'
		}
	});

	console.log('provider-walletconnect', provider.isWalletConnect);
	return provider;
}

function metamaskConnector() {
	provider = getInjectedProvider();
	return provider;
}

window.getChainId = async function getChainId() {
	let connected_by = window.localStorage.getItem('CONNECTED');
	if (provider) {
		const web3 = new Web3(provider);
		window.web3 = web3;
		if (provider.isMetaMask && window.web3.eth) {
			return await window.web3.eth.getChainId();
		} else if (provider.isWalletConnect) {
			return provider.chainId;
		}
	} else if (connected_by == 'magic') {
		const magicNetworkId =
			JSON.parse(window.localStorage.getItem('MAGIC_NETWORK_CHAINID')) ||
			gon.celoChainNetworkId;

		console.log('getChainId', magicNetworkId);
		// get chainID of magic user
		// const magic = await initMagic(magicNetworkId)
		// window.web3 = new Web3(magic.rpcProvider);

		// if (web3.eth) return await web3.eth.getChainId()
		return magicNetworkId;
	}

	if (window.ethereum) {
		return await window.ethereum.request({ method: 'net_version' });
	}

	return -1;
};

window.disconnect = async function disconnect(address) {
	await destroySession();
};

window.connect = async function connect(provider_name = 'injected') {
	console.log('connect', provider_name);
	if (provider_name === 'injected') {
		$('.metamask-loading').css('display', 'block');
		$('.w_btn_icon').hide();
		$('.walletconnect-loading').hide();
		// $('.magic-loading').hide();
		$('.w_btn_icon_wc').css('display', 'block');

		if (typeof window.ethereum === 'undefined') {
			$('.metamask-loading').hide();
			$('.w_btn_icon').css('display', 'block');
			$('.walletconnect-loading').hide();
			$('.w_btn_icon_wc').css('display', 'block');

			$('.w_btn').css('pointer-events', 'all');
			$('.w_btn_wc').css('pointer-events', 'all');

			return toastr.error(
				'MetaMask is not installed! Please follow the guide to install MetaMask.'
			);
		}
	} else if (provider_name == 'walletconnect') {
		$('.walletconnect-loading').css('display', 'block');
		$('.w_btn_icon_wc').hide();
		$('.metamask-loading').hide();
		// $('.magic-loading').hide();
		$('.w_btn_icon').css('display', 'block');
	} else {
		window.localStorage.setItem('CONNECTED', 'magic');

		$('.magic-loading').css('display', 'block');
		$('.connect-wallet__login-form__btn span').addClass('hide');
		$('.connect-wallet__login-form__btn').attr('disabled', 'true');
		$('.metamask-loading').hide();
		$('.walletconnect-loading').hide();
		$('.w_btn_icon').css('display', 'block');
	}

	$('.w_btn').css('pointer-events', 'none');
	$('.w_btn_wc').css('pointer-events', 'none');

	console.log('Opening a dialog', provider);

	if (['injected', 'walletconnect'].includes(provider_name)) {
		try {
			if (provider_name == 'walletconnect') {
				console.log('provider-wallet', provider);
				provider = await walletConnector();
				window.localStorage.setItem('CONNECTED', 'walletconnect');

				await provider.connect();
			} else {
				provider = await metamaskConnector();
				window.localStorage.setItem('CONNECTED', 'metamask');
				if (provider) {
					try {
						if (provider.request) {
							await window.ethereum
								.request({ method: 'eth_requestAccounts' })
								.catch(err => {
									if (err.code === 4001) {
										console.log('Please connect to MetaMask.');
									} else {
										console.error(err);
									}
								});
						}
					} catch (err) {
						if (err.code === 4001) {
							// EIP-1193 userRejectedRequest error
							// If this happens, the user rejected the connection request.
							userRejectedRequest = true;
							console.log('Please connect to MetaMask.');
						} else {
							console.error(err);
						}
					}
				} else {
					console.error(
						'Tried to connect to MetaMask but it was not detected. Please install MetaMask.'
					);
				}
				// Request user permission to connect

				// Connect to the injected provider
			}
		} catch (e) {
			console.log('Could not get a wallet connection', e);
			$('.metamask-loading').hide();
			$('.w_btn_icon').css('display', 'block');
			$('.walletconnect-loading').hide();
			$('.w_btn_icon_wc').css('display', 'block');

			$('.w_btn').css('pointer-events', 'all');
			$('.w_btn_wc').css('pointer-events', 'all');
			return;
		}
	}

	const status = await window.fetchAccountData(false, true);
	const locationUserProfile = $('#location-collectible');
	const btnCreateProfile = $('.profile-create-collection__btn');

	console.log('status', status);
	console.log('fetch', provider);

	if (provider) {
		await subscribeProvider();
	}

	if (status) {
		// Should reload the page with logged account
		// window.location.href = '/'
		if (locationUserProfile.val() && btnCreateProfile.hasClass('clicked')) {
			window.location.href = locationUserProfile.val();
		} else {
			location.reload();
		}
	} else {
		// toastr.error('Please install Metamask Extension to your browser.')
	}
};

function getInjectedProvider() {
	const ethereum = window.ethereum;
	let provider = ethereum || window.web3?.currentProvider;

	// if multiple providers are injected and one of them is Metamask, prefer Metamask
	if (ethereum?.providers?.length) {
		ethereum.providers.forEach(p => {
			if (p.isMetaMask) provider = p;
		});
	}
	return provider;
}

async function subscribeProvider() {
	console.log('subscribeProvider');
	// Subscribe to accounts change
	provider.on('accountsChanged', async function () {
		const status = await window.fetchAccountData();
		if (status) location.reload();
	});

	// Subscribe to chainId change
	provider.on('chainChanged', async function () {
		const status = await window.fetchAccountData();
		if (status) {
			const netid = await window.getChainId();
			window.setNetworkIdToCookie(netid);
			location.reload();
		}
	});
}

window.mixLazyMintedNFTWithPRGs = async function mixLazyMintedNFTWithPRGs(
	collectionId,
	sharedCollection,
	purchase,
	artSellRequest,
	artVoucher,
	prgSellRequests,
	prgVouchers,
	selectedPrgs,
	store_front_address,
	art_supporter_id
) {
	try {
		var account = await getCurrentAccount();

		window.contract_store_front = await getContract(
			store_front_address,
			'nft_store_front',
			sharedCollection
		);
		var gasPrices = await gasPrice();

		var gasLimit = await getGasLimit(
			window.contract_store_front.methods.mixLazyMintedNFTWithPRGs(
				purchase,
				artSellRequest,
				artVoucher,
				prgSellRequests,
				prgVouchers
			),
			account
		);

		var receipt = await window.contract_store_front.methods
			.mixLazyMintedNFTWithPRGs(
				purchase,
				artSellRequest,
				artVoucher,
				prgSellRequests,
				prgVouchers
			)
			.send({
				from: account,
				gas: gasLimit,
				gasPrice: String(gasPrices)
			});

		await updateCollectionMerged(
			collectionId,
			purchase['amountsPrg'],
			receipt.transactionHash,
			purchase['sendTo'],
			selectedPrgs,
			purchase['amountNft'],
			art_supporter_id
		);
		return window.collectionMintSuccess(collectionId, true);
	} catch (err) {
		console.error(err);
		if (err.message.includes('reverted by the EVM')) {
			return window.collectionMintFailed('This collectible is not for sale');
		}
		return window.collectionMintFailed(err['message']);
	}
};

window.mixLazyMintedNFTV1WithPRGs = async function mixLazyMintedNFTV1WithPRGs(
	collectionId,
	sharedCollection,
	purchase,
	artSellRequest,
	artVoucher,
	prgSellRequests,
	prgVouchers,
	selectedPrgs,
	store_front_address,
	art_supporter_id
) {
	try {
		var account = await getCurrentAccount();

		window.contract_store_front = await getContract(
			store_front_address,
			'nft_store_front',
			sharedCollection
		);
		var gasPrices = await gasPrice();
		var gasLimit = await getGasLimit(
			window.contract_store_front.methods.mixLazyMintedNFTV1WithPRGs(
				purchase,
				artSellRequest,
				artVoucher,
				prgSellRequests,
				prgVouchers
			),
			account
		);

		var receipt = await window.contract_store_front.methods
			.mixLazyMintedNFTV1WithPRGs(
				purchase,
				artSellRequest,
				artVoucher,
				prgSellRequests,
				prgVouchers
			)
			.send({
				from: account,
				gas: gasLimit,
				gasPrice: String(gasPrices)
			});

		await updateCollectionMerged(
			collectionId,
			purchase['amountsPrg'],
			receipt.transactionHash,
			purchase['sendTo'],
			selectedPrgs,
			purchase['amountNft'],
			art_supporter_id
		);
		return window.collectionMintSuccess(collectionId, true);
	} catch (err) {
		console.error(err);
		return window.collectionMintFailed(err['message']);
	}
};

window.mixExistingNFTWithPRGs = async function mixExistingNFTWithPRGs(
	collectionId,
	sharedCollection,
	purchase,
	artSellRequest,
	prgSellRequests,
	prgVouchers,
	selectedPrgs,
	store_front_address,
	art_supporter_id
) {
	try {
		var account = await getCurrentAccount();
		window.contract_store_front = await getContract(
			store_front_address,
			'nft_store_front',
			sharedCollection
		);
		var gasPrices = await gasPrice();

		var gasLimit = await getGasLimit(
			window.contract_store_front.methods.mixExistingNFTWithPRGs(
				purchase,
				artSellRequest,
				prgSellRequests,
				prgVouchers
			),
			account
		);

		// var gasLimit = 506663;
		var receipt = await window.contract_store_front.methods
			.mixExistingNFTWithPRGs(
				purchase,
				artSellRequest,
				prgSellRequests,
				prgVouchers
			)
			.send({
				from: account,
				gas: gasLimit,
				gasPrice: String(gasPrices)
			});

		await updateCollectionMerged(
			collectionId,
			purchase['amountsPrg'],
			receipt.transactionHash,
			purchase['sendTo'],
			selectedPrgs,
			purchase['amountNft'],
			art_supporter_id
		);
		return window.collectionMintSuccess(collectionId, true);
	} catch (err) {
		console.error(err);
		return window.collectionMintFailed(err['message']);
	}
};

window.signAndCreateVoucher = async function signAndCreateVoucher(
	tokenAddress,
	tokenURI,
	royalty,
	tokenId,
	collectionAddress,
	nftType = 'recycling_nft',
	amount = 1,
	new_sc = 'true'
) {
	try {
		var account = await getCurrentAccount();
		var signDomainVersion = SIGNING_DOMAIN_VERSION;
		var verifyingContract = plastikCryptoAddress;
		var voucher = {
			tokenAddress,
			tokenId: parseInt(tokenId),
			amount: parseInt(amount),
			tokenURI,
			creatorAddress: account,
			royalty: parseInt(royalty)
		};
		var domainType = {
			EIP712Domain: [
				{ name: 'name', type: 'string' },
				{ name: 'version', type: 'string' },
				{ name: 'chainId', type: 'uint256' },
				{ name: 'verifyingContract', type: 'address' }
			]
		};
		if (nftType === 'recycling_nft') {
			var primaryType = 'PRGVoucher';
			domainType.PRGVoucher = [
				{ name: 'tokenAddress', type: 'address' },
				{ name: 'tokenId', type: 'uint256' },
				{ name: 'amount', type: 'uint256' },
				{ name: 'tokenURI', type: 'string' },
				{ name: 'creatorAddress', type: 'address' }
			];
		} else if (nftType === 'art_nft' && new_sc == 'false') {
			var primaryType = 'NFTVoucher';
			signDomainVersion = OLD_SIGNING_DOMAIN_VERSION;
			var verifyingContract = plastikCryptoAddressOld;
			delete voucher.amount;
			domainType.NFTVoucher = [
				{ name: 'tokenAddress', type: 'address' },
				{ name: 'tokenId', type: 'uint256' },
				{ name: 'tokenURI', type: 'string' },
				{ name: 'creatorAddress', type: 'address' },
				{ name: 'royalty', type: 'uint96' }
			];
		} else {
			var primaryType = 'NFTVoucherV2';
			domainType.NFTVoucherV2 = [
				{ name: 'tokenAddress', type: 'address' },
				{ name: 'tokenId', type: 'uint256' },
				{ name: 'amount', type: 'uint256' },
				{ name: 'tokenURI', type: 'string' },
				{ name: 'creatorAddress', type: 'address' },
				{ name: 'royalty', type: 'uint96' }
			];
		}

		var domain = {
			name: SIGNING_DOMAIN_NAME,
			version: signDomainVersion,
			chainId: smartChainNetworkId,
			verifyingContract: verifyingContract
		};

		const dataToSign = JSON.stringify({
			types: domainType,
			domain: domain,
			primaryType: primaryType,
			message: voucher
		});

		console.log('Signing voucher', domain, dataToSign);
		console.log(
			'Signing voucher',
			JSON.stringify(domain),
			JSON.stringify(dataToSign)
		);

		let voucherSignature = null;
		await window.web3.currentProvider.sendAsync(
			{
				method: 'eth_signTypedData_v4',
				params: [account, dataToSign],
				from: account
			},
			function (err, result) {
				if (err) return console.dir(err);
				if (result.error) {
					return console.error('ERROR', result);
				}

				let connected_by = window.localStorage.getItem('CONNECTED');

				let signResult = result.result;
				if (connected_by == 'walletconnect') {
					signResult = result;
				}

				updateSignatureVoucher(collectionAddress, signResult, voucher);
				return window.collectionMintSuccess(collectionAddress);
			}
		);
	} catch (err) {
		console.error(err);
		return window.collectionMintFailed(err['message']);
	}
};

function updateSignatureVoucher(collectionId, sign, voucher) {
	var request = $.ajax({
		url: `/collections/${collectionId}/sign_voucher`,
		type: 'POST',
		async: false,
		data: { sign: sign, voucher: voucher },
		dataType: 'script'
	});
	request.done(function (msg) {
		console.log('Signature updated.');
	});
	request.fail(function (jqXHR, textStatus) {
		console.log('Signature update failed. Please contact support');
	});
}

// buyingAssetType = 1 # 721
// buyingAssetType = 0 # 1155
window.buyAsset = async function buyAsset(
	assetOwner,
	buyingAssetType,
	buyingAssetAddress,
	tokenId,
	unitPrice,
	buyingAssetQty,
	paymentAmt,
	paymentAssetAddress,
	decimals,
	sellerSign,
	collectionId,
	giftAddress = null
) {
	try {
		paymentAmt = roundNumber(mulBy(paymentAmt, 10 ** decimals), 0);
		unitPrice = roundNumber(mulBy(unitPrice, 10 ** decimals), 0);
		var compiledContractDetails = getContractABIAndBytecode(
			tradeContractAddress,
			'trade'
		);
		var abi = compiledContractDetails['compiled_contract_details']['abi'];
		var contract = await new window.web3.eth.Contract(
			abi,
			tradeContractAddress
		);
		var account = await getCurrentAccount();
		var buyerAddress = account;
		if (giftAddress) buyerAddress = giftAddress;

		var orderStruct = [
			assetOwner,
			giftAddress,
			paymentAssetAddress,
			buyingAssetAddress,
			buyingAssetType,
			unitPrice,
			paymentAmt,
			tokenId,
			buyingAssetQty
		];
		var gasPrices = await gasPrice();
		console.log(gasPrices);

		var gasLimit = await getGasLimit(
			contract.methods.buyAsset(orderStruct, splitSign(sellerSign)),
			account
		);

		var receipt = await contract.methods
			.buyAsset(orderStruct, splitSign(sellerSign))
			.send({ from: account, gas: gasLimit, gasPrice: String(gasPrices) });
		await updateCollectionBuy(
			collectionId,
			buyingAssetQty,
			receipt.transactionHash,
			buyerAddress
		);
		return window.buyPurchaseSuccess(collectionId);
	} catch (err) {
		console.error(err);
		return window.buyPurchaseFailed(err['message']);
	}
};

window.buyLazyMintedPRG = async function buyLazyMintedPRG(
	paymentDetails,
	paymentAmt,
	buyQuantity,
	giftAddress = null
) {
	try {
		if (
			paymentDetails['asset_storefront_address'] !== storeFrontAddress &&
			paymentDetails['contract_version'] === gon.latestVersion
		) {
			return window.buyPurchaseFailed('Wrong Network! Buy fail!');
		}

		if (paymentDetails['contract_version'] !== gon.latestVersion) {
			storeFrontAddress = paymentDetails['asset_storefront_address'];
		}

		var compiledContractDetails = getContractABIAndBytecode(
			storeFrontAddress,
			'nft_store_front'
		);
		var abi = compiledContractDetails['compiled_contract_details']['abi'];
		var contract = await new window.web3.eth.Contract(abi, storeFrontAddress);
		var collectionId = paymentDetails['collection_id'];
		var account = await getCurrentAccount();
		var buyerAddress = account;
		if (giftAddress) buyerAddress = giftAddress;

		var decimals = toNum(paymentDetails['pay_token_decimal']);
		var unitPrice = toNum(paymentDetails['unit_price']);
		var paymentAmt = roundNumber(mulBy(paymentAmt, 10 ** decimals), 0);
		unitPrice = roundNumber(mulBy(1, 10 ** decimals), 0);
		var quantity = toNum(buyQuantity);
		var voucherInfo = paymentDetails['voucher_info'];
		const priceRatio = await fetchPriceRatio();

		var sellRequest = [
			paymentDetails['asset_address'],
			toNum(paymentDetails['token_id']),
			toNum(unitPrice),
			toNum(voucherInfo['amount']),
			paymentDetails['pay_token_address'],
			toNum(paymentDetails['donation']) * 100,
			paymentDetails['owner_address']
		];
		sellRequest = sellRequest.filter(function (el) {
			return el != null;
		});

		var purchasePRG = [
			sellRequest,
			paymentDetails['sign_instant_sale_price'],
			priceRatio.sellPrice,
			priceRatio.signature,
			quantity,
			buyerAddress
		];

		var PRGVoucher = [
			voucherInfo['tokenAddress'],
			toNum(voucherInfo['tokenId']),
			toNum(voucherInfo['amount']),
			voucherInfo['tokenURI'],
			voucherInfo['creatorAddress']
		];

		var gasPrices = await gasPrice();
		var gasLimit = await getGasLimit(
			contract.methods.buyLazyMintedPRG(
				purchasePRG,
				PRGVoucher,
				paymentDetails['sign_voucher_token']
			),
			account
		);

		var receipt = await contract.methods
			.buyLazyMintedPRG(
				purchasePRG,
				PRGVoucher,
				paymentDetails['sign_voucher_token']
			)
			.send({ from: account, gas: gasLimit, gasPrice: String(gasPrices) });

		await updateCollectionBuy(
			collectionId,
			quantity,
			receipt.transactionHash,
			buyerAddress
		);
		return window.buyPurchaseSuccess(collectionId);
	} catch (err) {
		console.error(err);
		return window.buyPurchaseFailed(err['message']);
	}
};

async function getGasLimit(method, account) {
	const gasLimit = await method.estimateGas({
		from: account
	});

	return roundNumber(mulBy(toNum(gasLimit), toNum(1.1)), 0);
}
async function gasPrice() {
	var init_gasPrice = '50000000000';
	try {
		const result = await web3.eth.getGasPrice();
		init_gasPrice = result;
	} catch (err) {
		console.error(err);
	}
	return init_gasPrice;
}

const toHex = num => {
	return '0x' + Number(num).toString(16);
};
window.addNetwork = async function addNetwork(selectedNetwork) {
	let chainId =
		selectedNetwork === 'BSC'
			? parseInt(gon.smartChainNetworkId)
			: parseInt(gon.celoChainNetworkId);
	let chainIdHex = toHex(chainId);
	let chainName = 'Binance Smart Chain';
	let nativeCurrency = 'BNB';
	let rpcUrl = 'https://bsc-dataseed.binance.org/';
	let blockExplorer = 'https://bscscan.com';
	try {
		if (chainId == 97) {
			chainName = 'BSC Testnet';
			nativeCurrency = 'BNB';
			rpcUrl = 'https://data-seed-prebsc-1-s1.binance.org:8545';
			blockExplorer = 'https://testnet.bscscan.com';
		} else if (selectedNetwork === 'CELO') {
			if (chainId == 42220) {
				chainName = 'Celo Mainnet';
				nativeCurrency = 'CELO';
				rpcUrl = 'https://forno.celo.org';
				blockExplorer = 'https://explorer.celo.org';
			} else {
				chainName = 'Celo Alfojares';
				nativeCurrency = 'CELO';
				rpcUrl = 'https://alfajores-forno.celo-testnet.org';
				blockExplorer = 'https://alfajores-blockscout.celo-testnet.org';
			}
		}
		await window.ethereum.request({
			method: 'wallet_switchEthereumChain',
			params: [{ chainId: chainIdHex }]
		});
	} catch (error) {
		if (
			[4902, -32603].includes(error.code) ||
			error?.data?.orginalError?.code === 4902
		) {
			try {
				await window.ethereum.request({
					method: 'wallet_addEthereumChain',
					params: [
						{
							chainId: chainIdHex,
							chainName: chainName,
							nativeCurrency: {
								name: nativeCurrency,
								symbol: nativeCurrency,
								decimals: 18
							},
							rpcUrls: [rpcUrl],
							blockExplorerUrls: [blockExplorer],
							iconUrls: ['']
						}
					]
				});
			} catch (addError) {
				throw new Error('Cannot add network');
			}
		} else {
			throw new Error('Cannot add network');
		}
	}

	const currentChainId = await getNetworkId();

	if (chainId !== currentChainId) throw new Error('Switch network failed');
};

window.getCeloBalance = async function getCeloBalance() {
	let celoNativeTokenAddress = gon.celoNativeTokenAddress;
	let celoNativeTokenDecimals = gon.celoNativeTokenDecimals;

	let celoBalanace = await tokenBalance(
		celoNativeTokenAddress,
		celoNativeTokenDecimals
	);

	return celoBalanace;
};

window.showDataWallet = async function showDataWallet() {
	let plastikBalance = await tokenBalance(
		plastikTokenAddress,
		plastikTokenDecimals
	);
	let plastikUsdPrice = gon.plastikUsdPrice;
	let celoBalanace = await window.getCeloBalance();
	let celoUsdPrice = gon.celoUsdPrice;
	// if(plastikBalance > 0){
	//   $('#my-wallet-amount-plastik, #my-wallet-amount-plastik-usd').removeClass('d-none')
	//   $('#my-wallet-amount-plastik').html(formatFloatNumber(plastikBalance))
	//   $('#my-wallet-amount-plastik-usd').html('$' + formatFloatNumber(plastikBalance * plastikUsdPrice) + ' USD')
	// }else{
	//   $('#wallet_get_plastik').removeClass('d-none');
	// }
	$('#my-wallet-amount-plastik').html(formatFloatNumber(plastikBalance));
	$('#my-wallet-amount-plastik-usd').html(
		'$' + formatFloatNumber(plastikBalance * plastikUsdPrice) + ' USD'
	);

	if (celoBalanace > 0) {
		$('#wallet-celo-balance-section').removeClass('d-none');
		$('#my-wallet-amount-celo').html(formatFloatNumber(celoBalanace));
		$('#my-wallet-amount-celo-usd').html(
			'$' + formatFloatNumber(+celoBalanace * celoUsdPrice) + ' USD'
		);
	}

	$('.send-plastik__input-group--amount--balance').html(
		'Balance ' +
			parseFloat(plastikBalance).toLocaleString(undefined, {
				minimumFractionDigits: 4
			}) +
			' PLASTIK'
	);
	$('#plastik-balance').val(parseFloat(plastikBalance));
	console.log('reload plastikBalance');
};

function formatFloatNumber(val) {
	let num = parseFloat(val).toFixed(2);
	let formattedNum = parseFloat(num).toLocaleString();
	return formattedNum;
}

window.initSendProcess = async (amount, toAddress) => {
	const contractAddress = plastikTokenAddress;
	const compiledContractDetails = getContractABIAndBytecode(
		contractAddress,
		'erc20',
		false
	);
	const abi = compiledContractDetails['compiled_contract_details']['abi'];
	const contract = await new window.web3.eth.Contract(abi, contractAddress);
	const account = await getCurrentAccount();
	const gasPrice = await window.web3.eth.getGasPrice();

	amount = amount * Math.pow(10, plastikTokenDecimals);
	const amountValue = web3.utils.toBN(amount);

	await contract.methods
		.transfer(toAddress, amountValue)
		.send({ from: account })
		.on('transactionHash', function (hash) {
			console.log(hash);
		})
		.on('receipt', function (receipt) {
			console.log(receipt);
			toastr.success('The token transfer was successful');
			resetSendTokenForm();
			showDataWallet();
		})
		.on('error', function (receipt) {
			toastr.error('The token transfer failed');
			resetSendTokenForm();
		});
};

const resetSendTokenForm = () => {
	$('#input-plastik-amount').val('');
	$('#input-address-receive').val('');
	$('#input-address-receive').prop('disabled', false);
	$('#input-plastik-amount').prop('disabled', false);
	$('#progress-status-loading').addClass('d-none');
	$('#send-plastiks .btn-text').removeClass('d-none');
};

window.getMaxGasFeesTotal = async function (toAddress, amount) {
	const contractAddress = plastikTokenAddress;
	const compiledContractDetails = getContractABIAndBytecode(
		contractAddress,
		'erc20',
		false
	);
	const abi = compiledContractDetails['compiled_contract_details']['abi'];
	const contract = await new window.web3.eth.Contract(abi, contractAddress);
	const account = await getCurrentAccount();
	const gasPrice = await window.web3.eth.getGasPrice();

	amount = amount * Math.pow(10, plastikTokenDecimals);
	const amountValue = web3.utils.toBN(amount);

	// Estimate the gas cost
	const gas = await contract.methods
		.transfer(toAddress, amountValue)
		.estimateGas({ from: account });
	let gasFee = gas * gasPrice;
	gasFee = window.web3.utils.fromWei(gasFee.toString(), 'ether');
	$('#gas-fees-total').text(parseFloat(gasFee).toFixed(6));
};

$(document).on('click', '.connect-wallet--socials', async function (e) {
	const provider = $(this).data('provider');
	window.localStorage.setItem('CONNECTED', 'magic');

	await magicOauthLogin(provider);

	function receiveMessageFromLoginPopUp(event) {
		if (event.origin !== window.location.origin) return;

		if (event.data) {
			if (event.data.oauth_login == 'success') window.location.reload();
		}
	}

	window.addEventListener('message', receiveMessageFromLoginPopUp, false);
});

async function magicOauthLogin(provider = 'google') {
	const magic = await initMagic();

	window.localStorage.setItem('MAGIC_SOCIAL_LOGIN_HREF', window.location.href);

	await magic.oauth.loginWithRedirect({
		provider: provider,
		redirectURI: `${window.location.origin}/sessions/oauth_callback`
	});
}

window.fetchAccountData = async function fetchAccountData(
	shoulDestroySession = false,
	fetchWhenLogin = false,
	stepRetry = 0
) {
	let chainId = null;
	let networkType = null;
	let userInfo = null;
	let userMail = null;
	let connected_by = window.localStorage.getItem('CONNECTED');

	if (provider) {
		console.log('provider-fetch-account', provider);
		const web3 = new Web3(provider);
		window.web3 = web3;
		console.log('Web3 instance is', web3);

		if (provider.isMetaMask) {
			chainId = await window.web3.eth.getChainId();
			selectedAccount = (await web3.eth.getAccounts())[0];
		} else if (provider.isWalletConnect) {
			selectedAccount = await provider.accounts[0];
			console.log('isWalletConnect', selectedAccount);

			chainId = provider.chainId;
			console.log('chainId', chainId);
			await setChainId();
			provider.networkId = smartChainNetworkId;
		}

		// if (chainId !== smartChainNetworkId) {
		//   $(".loading-gif-network").show();
		//   return false
		// }

		if (provider.isMetaMask && fetchWhenLogin) {
			try {
				await connectMetaMaskSteps(chainId, stepRetry);
			} catch (error) {
				return false;
			}
		}

		networkType = await getNetworkType(provider);
	} else if (connected_by == 'magic') {
		let selectedNetworkChainId;

		if ($.magnificPopup.instance.isOpen) {
			selectedNetworkChainId =
				$('.network-select.active')?.data('chain-id') || gon.celoChainNetworkId;
		} else {
			selectedNetworkChainId =
				JSON.parse(window.localStorage.getItem('MAGIC_NETWORK_CHAINID')) ||
				gon.celoChainNetworkId;
		}

		const magic = await initMagic(selectedNetworkChainId);
		const web3 = new Web3(magic.rpcProvider);
		window.web3 = web3;

		if ($('#connect-wallet__login-form__email').length) {
			userMail = $('#connect-wallet__login-form__email').val().trim();
			try {
				window.localStorage.setItem(
					'MAGIC_SOCIAL_LOGIN_HREF',
					window.location.href
				);
				await handleLoginWithMailOTP(magic, userMail);
				return;
			} catch (e) {
				toastr.error('Something went wrong! Please try again later.');
				$('.magic-loading').hide();
				$('.connect-wallet__login-form__btn span').removeClass('hide');

				return false;
			}
		}

		let isLoggedIn = await magic.user.isLoggedIn();
		if (isLoggedIn) {
			const { publicAddress } = await magic.user.getInfo();
			selectedAccount = publicAddress;
		}
	}

	console.log('Got account', selectedAccount);
	if (selectedAccount) {
		var plastikBalanace = await updateBalance();
		var isValidUserResp = null;

		console.log('BALANCE', plastikBalanace);
		isValidUserResp = JSON.parse(
			window.localStorage.getItem('VALID_USER_RESPONSE')
		);

		console.log('isValidUserResp', isValidUserResp);
		if (selectedAccount && !isValidUserResp) {
			const token = document.querySelector('[name=csrf-token]').content;
			const res = await isValidUser(selectedAccount, token);
			isValidUserResp = res.user_exists;
			console.log('user_exists', isValidUserResp);
			window.localStorage.setItem('VALID_USER_RESPONSE', isValidUserResp);
		}

		console.log('isValidUserResp', isValidUserResp);
		if (isValidUserResp) {
			console.log('user exists');
			if (selectedAccount) {
				await createUserSession(
					selectedAccount,
					plastikBalanace,
					shoulDestroySession,
					userInfo
				);
			}
			console.log('session created', shoulDestroySession);
			if (shoulDestroySession) {
				window.location.href = `/${window.prefixPath}`;
			} else {
				if (!stepRetry) return true;
			}
		} else {
			console.log('user do not exists');

			if (gon.session) {
				if (selectedAccount) {
					await destroySession();
				}
				window.location.href = `/${window.prefixPath}`;
			} else if (selectedAccount && fetchWhenLogin) {
				console.log('showing terms and conditions');
				await showTermsCondition(
					selectedAccount,
					plastikBalanace,
					networkType,
					userMail
				);
				return false;
			}
		}
	} else if (!selectedAccount && gon.session) {
		toastr.error('You got logged out due to session ended');
		await destroySession();
		return false;
	}
	if (fetchWhenLogin && stepRetry) {
		window.location.href = `/${window.prefixPath}`;
	}

	return false;
};

const handleLoginWithMailOTP = async (magic, userMail) => {
	const handle = magic.auth.loginWithEmailOTP({
		email: userMail,
		showUI: true
	});
	await handle
		.on('invalid-email-otp', () => {
			handle.emit('cancel');
		})
		.on('done', async result => {
			const userInfo = await magic.user.getInfo();
			await $.post(`${window.location.origin}/sessions/magic_auth_callback`, {
				magic_credential: result
			})
				.done(response => {
					let publicAddress = response?.data?.data?.public_address;
					try {
						window.smartlook('identify', publicAddress, gon.currentUserInfo);
					} catch (e) {
						console.log(`===Smartlook error on identify: ${e} ===`);
					}
					toastr.success('Successfully logged in');
					window.localStorage.setItem('CONNECTED', 'magic');
					window.localStorage.setItem('VALID_USER_RESPONSE', true);
					console.log('public address', publicAddress);
					window.location.reload();
				})
				.fail(async error => {
					console.log('error', error);
				});
		})
		.on('error', reason => {
			console.error(reason);
		})
		.on('device-verification-link-expired', () => {
			handle.emit('device-retry');
		});
};

const isUserAddedToken = async chainID => {
	const token = document.querySelector('[name=csrf-token]').content;
	const addedTokenStatus = await isValidUser(selectedAccount, token);

	if (addedTokenStatus && addedTokenStatus.added_token_status)
		return addedTokenStatus.added_token_status[chainID];

	return false;
};

window.connectMetaMaskStep2 = async function connectMetaMaskStep2() {
	const selectedNetworkChainId =
		$('.network-select.active')?.data('chain-id') || gon.celoChainNetworkId;

	try {
		if (!$('.connect-wallet__login-step--error.step-2').hasClass('hide'))
			$('.connect-wallet__login-step--error.step-2').addClass('hide');

		await addNetwork(
			[97, 56].includes(parseInt(selectedNetworkChainId)) ? 'BSC' : 'CELO'
		);

		// Done step 2
		$('.connect-wallet__login-step--btn.active')
			.not('.done')
			.html("<img src='/assets/checkmark-white.svg'><img>");
		$('.connect-wallet__login-step--btn.active').not('.done').addClass('done');
		$('.connect-wallet__login-step--btn')
			.not('.active')
			.first()
			.addClass('active');
	} catch (error) {
		$('.connect-wallet__login-step--error.step-2').removeClass('hide');

		selectedAccount = null;
		throw new Error(error);
	}

	return true;
};

window.connectMetaMaskStep3 = async function connectMetaMaskStep3() {
	try {
		if (!$('.connect-wallet__login-step--error.step-3').hasClass('hide'))
			$('.connect-wallet__login-step--error.step-3').addClass('hide');

		const chainID = await window.getChainId();
		// Add token to user wallet if they added it
		const isAdded = await isUserAddedToken(chainID);

		if (!isAdded) {
			await setChainId();
			await registerTokenToWallet(plastikTokenAddress);
		}

		// Done step 3
		$('.connect-wallet__login-step--btn.active')
			.not('.done')
			.html("<img src='/assets/checkmark-white.svg'><img>");
		$('.connect-wallet__login-step--btn.active').not('.done').addClass('done');
		$('.connect-wallet__login-step--btn')
			.not('.active')
			.first()
			.addClass('active');
	} catch (error) {
		$('.connect-wallet__login-step--error.step-3').removeClass('hide');

		selectedAccount = null;
		throw new Error(error);
	}

	return true;
};

window.connectMetaMaskSteps = async function connectMetaMaskSteps(
	chainId,
	stepRetry = null
) {
	const selectedNetworkChainId = gon.celoChainNetworkId;

	if (
		selectedNetworkChainId &&
		(chainId != selectedNetworkChainId || stepRetry) &&
		$.magnificPopup.instance.isOpen
	) {
		// open modal
		$('span#selected-network').html(
			getNetWorkName(
				$('.network-select.active')?.data('chain-id') || gon.celoChainNetworkId
			)
		);
		$('#connect-wallet__login-metamask').css('display', 'block');
		$('#connect-wallet__welcome').css('display', 'none');
		$('#connect-wallet__connect-wallet').css('display', 'none');

		if (selectedAccount) {
			// Done step 1
			if (!stepRetry) {
				$('.connect-wallet__login-step--btn.active')
					.not('.done')
					.html("<img src='/assets/checkmark-white.svg'><img>");
				$('.connect-wallet__login-step--btn.active')
					.not('.done')
					.addClass('done');
				$('.connect-wallet__login-step--btn')
					.not('.active')
					.first()
					.addClass('active');
			}

			try {
				if (chainId != selectedNetworkChainId) {
					await connectMetaMaskStep2();
				} else {
					// Done step 2
					if (!stepRetry) {
						$('.connect-wallet__login-step--btn.active')
							.not('.done')
							.html("<img src='/assets/checkmark-white.svg'><img>");
						$('.connect-wallet__login-step--btn.active')
							.not('.done')
							.addClass('done');
						$('.connect-wallet__login-step--btn')
							.not('.active')
							.first()
							.addClass('active');
					}
				}
			} catch (error) {
				throw new Error(error);
			}

			await connectMetaMaskStep3();

			return true;
		}
	}

	return false;
};

async function registerTokenToWallet(
	tokenAddress,
	tokenSymbol = 'PLASTIK',
	tokenDecimals = 9,
	tokenImage = null
) {
	const chainID = await window.getChainId();

	try {
		await ethereum
			.request({
				method: 'wallet_watchAsset',
				params: {
					type: 'ERC20',
					options: {
						address: tokenAddress,
						symbol: tokenSymbol,
						decimals: tokenDecimals,
						image: tokenImage || $('#token-img').html()
					}
				}
			})
			.then(success => {
				if (success) {
					console.log('PLASTIK successfully added to wallet!');

					// save info of user added token
					let currentAddedTokenStatus =
						JSON.parse(window.localStorage.getItem('ADDED_TOKEN_STATUS')) || {};
					currentAddedTokenStatus[chainID] = true;

					window.localStorage.setItem(
						'ADDED_TOKEN_STATUS',
						JSON.stringify(currentAddedTokenStatus)
					);
				} else {
					throw new Error('Something went wrong.');
				}
			})
			.catch(error => {
				throw new Error(error);
			});
	} catch (error) {
		throw new Error(error);
	}
}

async function showTermsCondition(
	account,
	plastikBalanace,
	networkType,
	userMail
) {
	var account = account || getCurrentAccount();
	console.log('showTermsCondition: ', account);
	// $("#terms-and-condition").modal("show")
	$.magnificPopup.open({
		closeOnBgClick: false,
		enableEscapeKey: false,
		items: {
			src: '#terms-and-condition'
		},
		type: 'inline'
	});
	$('#account').val(account);
	$('#eth_balance_tc').val(plastikBalanace);
	$('#network_type').val(networkType);
	$('#user_mail').val(userMail);
}

const isNetworkError = error => {
	error && !error.response && error.code !== 'ECONNABORTED';
};

async function isValidUser(address, token = '') {
	token = document.querySelector('[name=csrf-token]').content;
	console.log('tokken is valid', token);

	const config = {
		headers: {
			'X-CSRF-TOKEN': token,
			Accept: 'application/json',
			'Content-Type': 'application/json'
		}
	};

	const resp = await $.get(`/sessions/valid_user`, {
		address: address,
		authenticity_token: token
	})
		.then(response => {
			console.log('validate user', response);
			window.localStorage.setItem('VALID_USER_RESPONSE', response.user_exists);

			return response;
		})
		.catch(err => {
			console.log('User Session Validate Error', err);
		});
	return resp;
}

window.getCurrentAccount = async function getCurrentAccount() {
	let connected_by = window.localStorage.getItem('CONNECTED');
	if (connected_by == 'magic' && gon.isLoggedIn) {
		const magicNetworkId =
			JSON.parse(window.localStorage.getItem('MAGIC_NETWORK_CHAINID')) ||
			gon.celoChainNetworkId;
		const magic = await initMagic(magicNetworkId);
		const { publicAddress } = await magic.user.getInfo();
		return publicAddress;
	} else {
		return selectedAccount;
	}
};

async function destroyUserSession(address) {
	await $.ajax({
		url: `/sessions/${address}`,
		type: 'DELETE',
		contentType: 'application/json',
		headers: {
			'X-CSRF-TOKEN': document.querySelector('[name=csrf-token]').content
		},
		success: function (result) {
			console.log(result);
		},
		error: function (request, error) {
			console.log('Session destroy: ', error);
		}
	});
}

export async function destroySession() {
	$('.metamask-loading').hide();
	$('.w_btn_icon').css('display', 'block');

	$('.walletconnect-loading').hide();
	$('.w_btn_icon_wc').css('display', 'block');

	$('.magic-loading').hide();
	$('.connect-wallet__login-form__btn span').removeClass('hide');

	$('.w_btn').css('pointer-events', 'all');
	$('.w_btn_wc').css('pointer-events', 'all');

	if (gon.session) {
		await destroyUserSession(selectedAccount || gon.current_user_address);
	}

	if (provider && provider.close) {
		await provider.close();
	} else if (provider && provider.disconnect) {
		await provider.disconnect();
	} else {
		let connected_by = window.localStorage.getItem('CONNECTED');
		if (connected_by == 'magic') {
			const magicNetworkId =
				JSON.parse(window.localStorage.getItem('MAGIC_NETWORK_CHAINID')) ||
				gon.celoChainNetworkId;

			// get chainID of magic user
			const magic = await initMagic(magicNetworkId);

			try {
				let isLoggedIn = await magic.user.isLoggedIn();
				console.log('is logged in', isLoggedIn);
				if (isLoggedIn) {
					await magic.user.logout();
				}
			} catch (e) {
				console.log(e);
			}
		}
	}

	resetProvider();
	window.localStorage.removeItem('wc@2:core:0.3//keychain');
	window.localStorage.removeItem('wc@2:core:0.3//messages');
	window.localStorage.removeItem('wc@2:client:0.3//proposal');
	window.localStorage.removeItem('wc@2:universal_provider:/namespaces');
	window.localStorage.removeItem('wc@2:core:0.3//subscription');
	window.localStorage.removeItem('VALID_USER_RESPONSE');
	window.localStorage.removeItem('CONNECTED');
	selectedAccount = null;

	window.location.href = `/${window.prefixPath}`;
}

async function resetProvider() {
	provider = null;
}

async function fundingToUser(minFee = 0.002) {
	let plastikBalance = await tokenBalance(
		plastikTokenAddress,
		plastikTokenDecimals
	);
	let celoBalance = await window.getCeloBalance();
	let account = await getCurrentAccount();
	if (account) {
		if (parseFloat(parseFloat(celoBalance).toFixed(3)) < parseFloat(minFee)) {
			await $.post(`/fund-users`, {
				address: account,
				fundingChain: parseInt(gon.celoChainNetworkId)
			})
				.done(response => {
					window.localStorage.setItem('RECEIVED_CELO', true);
					console.log('received celo');
				})
				.fail(function () {
					console.log('error!');
				});

			console.log('before delay ...');
			await delay(3000);
			console.log('done delay ...');
		}
	}
}

async function saveCollectionCreatedToFirestore(firstTransactionHash) {
	await $.post(`/save-collection-created`, {
		collectionChain: parseInt(gon.celoChainNetworkId),
		transactionHash: firstTransactionHash
	})
		.done(response => {
			window.localStorage.removeItem('RECEIVED_CELO');
			window.localStorage.removeItem('FIRST_TRANSACTION_HASH');
			console.log('stored collection to firestore');
		})
		.fail(function () {
			console.log('error!');
		});
}

const delay = delayInms => {
	return new Promise(resolve => setTimeout(resolve, delayInms));
};

export { provider, web3Modal, resetProvider, smartChainNetworkId };
